import Vue from 'vue'
import Router from 'vue-router'
// rebuild
// import store from './store'
Vue.use(Router)
// Name of the localStorage item
const AUTH_TOKEN = '_lp.at'
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Pages
        {
          name: 'My Account',
          path: '/my-account',
          component: () => import('@/views/dashboard/pages/MyAccount'),
        },
        {
          name: 'Manager Forecast',
          path: '/manager-forecast',
          component: () => import('@/views/dashboard/pages/ManagerForecast'),
        },
        {
          name: 'Biometrics',
          path: '/biometrics',
          component: () => import('@/views/dashboard/pages/Biometrics'),
        },
        {
          name: 'Settings',
          path: '/settings',
          component: () => import('@/views/dashboard/pages/Settings'),
        },
        {
          name: 'Schedules',
          path: '/schedules',
          component: () => import('@/views/dashboard/pages/Schedules'),
        },
        {
          name: 'Crew List',
          path: '/crew',
          component: () => import('@/views/dashboard/pages/CrewList'),
        },
        {
          name: 'Reports',
          path: '/reports',
          component: () => import('@/views/dashboard/pages/Reports'),
        },
        {
          name: 'Users',
          path: '/users',
          component: () => import('@/views/dashboard/pages/Users'),
        },
        {
          name: 'Stores',
          path: '/stores',
          component: () => import('@/views/dashboard/pages/Stores'),
        },
      ],
      beforeEnter: (to, from, next) => {
        if (localStorage) {
          if (!localStorage.getItem(AUTH_TOKEN)) {
            return next({ name: 'login' })
          }
        } else {
          return next({ name: 'login' })
        }
        return next()
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/Login'),
    },
    {
      path: '/reset-password',
      name: 'reset',
      component: () => import('@/ResetPassword'),
    },
    {
      path: '/password/reset/:token',
      name: 'reset-token',
      component: () => import('@/ResetPasswordToken'),
    },
    {
      path: '/verification/password/setup/:token',
      name: 'verify',
      component: () => import('@/VerifyAccount'),
    },
    {
      path: '*',
      name: '404',
      component: () => import('@/404'),
    },
  ],
})
